import React from 'react'
import { Loader } from '@web/walter-ui-kit'

import commonStyles from '../style.module.css'
import styles from './style.module.css'

function Preloader() {
    return (
        <div className={commonStyles.wrap}>
            <div className={styles.text}>
                <div className={styles.textTop}>
                    <Loader width="100%" height={31} />
                </div>
                <div className={styles.textBottom}>
                    <Loader width={232} height={18} />
                </div>
            </div>
            <div className={styles.button}>
                <Loader width="100%" height={42} />
            </div>
        </div>
    )
}

export default Preloader
